import { api } from '../config';

/**
 * Helper function to get the correct image URL
 * If the image path starts with http (S3 URL), return it as is
 * Otherwise, construct the URL with API endpoint and upload directory
 * 
 * @param {string} imagePath - The image path or URL
 * @param {string} uploadDir - The upload directory (e.g., categoryUploadDir)
 * @returns {string} - The complete image URL
 */
export const getImageUrl = (imagePath, uploadDir) => {
    if (!imagePath) return '';
    
    // If it's already a full URL (S3 or external), return as is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }
    
    // Otherwise, construct the local API URL
    return `${api?.apiEndpoint || ''}${uploadDir || ''}${imagePath}`;
};

export default getImageUrl;